import React, { useState } from 'react';
import styled from 'styled-components';
import { Icon } from 'components/common/Icon';
import { Box, RowBox } from 'styles';

export function Input({ value, onChange, searchOnClick, cleanOnClick }) {
  const [active, setActive] = useState(false);

  const inputOnChange = (e) => {
    onChange(e.target.value);
  };

  const onClick = () => {
    setActive(true);
    searchOnClick();
    setTimeout(() => {
      setActive(false);
    }, 300);
  };

  return (
    <RowBox $padding="8px 16px" $gap={4}>
      <InputContainer>
        <Icon name="InputSearch" $padding="6px 8px" />
        <input value={value || ''} onChange={inputOnChange} />
        <Icon
          $padding="10px 12px"
          $visibility={value ? 'visible' : 'hidden'}
          name="InputDel"
          onClick={() => cleanOnClick && cleanOnClick()}
        />
      </InputContainer>
      <InputButton onClick={onClick} $active={active}>
        검색
      </InputButton>
    </RowBox>
  );
}

const InputContainer = styled.div`
  display: flex;
  align-items: center;
  border-radius: 8px;
  padding: 0 8px;
  border: 1px solid ${({ theme }) => theme.colors.fill20};
  gap: 4px;
  width: calc(100% - 44px);

  & > input {
    width: calc(100% - 46px);
    color: #171717;
    font-size: 16px;
  }
`;

const InputButton = styled.button`
  font-size: 14px;
  line-height: 1;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.assistive};
  background-color: ${({ $active, theme }) => ($active ? theme.colors.fill05 : 'transparent')};
  min-width: 40px;
  width: 40px;
  height: 40px;
  border-radius: 8px;
`;
